import { useState } from 'react'

import AssistantInfo from '../../../Components/MACCS/Internships/AssistantInfo'
import SchoolAssistants from '../../../Components/MACCS/Assistants/SchoolAssistants'
import SmartTableProvider, { SmartTableContext } from '../../../Context/Assistants/SmartTableProvider'
import AdminResetPassword from '../../../Components/shared/AdminResetPassword'

import '../../../assets/assistants-view.scss'

const AssistantsView = () => {
  const [selectedAssistant, setSelectedAssistant] = useState(null)
  const [selectedAssistantForPasswordReset, setSelectedAssistantForPasswordReset] = useState(null)

  return (
    <>
      <SmartTableProvider
        onSelectAssistant={setSelectedAssistant}
        onPasswordReset={setSelectedAssistantForPasswordReset}
      >
        <SchoolAssistants customContext={SmartTableContext} />
      </SmartTableProvider>
      <AssistantInfo
        assistant={selectedAssistant}
        onClose={() => setSelectedAssistant(null)}
      />
      <AdminResetPassword
        userToResetPassword={selectedAssistantForPasswordReset}
        onClose={() => setSelectedAssistantForPasswordReset(null)}
        person='assistantId'
      />
    </>
  )
}

export default AssistantsView
